import request from '@/utils/request'

export function ExcellentCaseList(data) {
  return request({
    url: '/health-doctor-assistant/workOrderExcellentCase/list',
    method: 'post',
    data
  })
}

export function ExcellentCaseDelete(data) {
  return request({
    url: '/health-doctor-assistant/workOrderExcellentCase/delete',
    method: 'post',
    data
  })
}

export function ExcellentCaseUpdate(data) {
  return request({
    url: '/health-doctor-assistant/workOrderExcellentCase/update',
    method: 'post',
    data
  })
}

export function ExcellentCaseDetail(data) {
  return request({
    url: '/health-doctor-assistant/workOrderExcellentCase/detail',
    method: 'get',
    params: data
  })
}
